import { AppIndex } from "~lib/App";
import { AppName } from "~shared/messageTypes";
import { LobbyApp } from "./LobbyApp";

export const Lobby: AppIndex = {
  hidden: true,
  id: AppName.LOBBY,
  name: "Lobby",
  app: LobbyApp,
};
